import React from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { AddCircle as WalkInIcon } from '@mui/icons-material';
import AppointmentService from '../services/appointmentTimelineService';

// Crear instancia del servicio
const appointmentService = new AppointmentService();

const WalkinButtonComponent = ({ appointment, onStatusChange }) => {
  const handleWalkInClick = async (e) => {
    e.stopPropagation();

    if (!appointment || !appointment.id) {
      console.error('❌ Invalid appointment for Walk-in');
      return;
    }

    try {
      console.log('🚶 Marking as Walk-in:', {
        patientName: appointment.patientName,
        appointmentId: appointment.id,
        currentStatus: appointment.status
      });

      // Llamar al servicio para marcar como Walk-in
      const updated = await appointmentService.markAsWalkIn(appointment.id, {
        status: 'Walk in',
        notes: `Walk-in appointment created at ${new Date().toLocaleString()}`
      });

      console.log('✅ Walk-in success:', {
        id: updated._id || updated.id,
        newStatus: updated.status,
        patientName: updated.patientName
      });

      // IMPORTANTE: Usar el ID correcto para el callback
      // El appointment.id es el MongoDB _id que usa la tabla
      if (onStatusChange) {
        onStatusChange(appointment.id, 'Walk in');
      }

      // Recargar la página después del éxito
      window.location.reload();

    } catch (error) {
      console.error('❌ Error marking appointment as Walk-in:', error);
      
      // Opcional: Mostrar notificación de error al usuario
      // Si tienes un sistema de notificaciones, úsalo aquí
      alert(`Error marking appointment as Walk-in: ${error.message}`);
    }
  };

  // Verificar si el botón debe estar disponible según el estado
  const isDisabled = () => {
    const disabledStatuses = ['Completed', 'Cancelled', 'No Show', 'Walk in'];
    return disabledStatuses.includes(appointment.status);
  };

  // Si ya es Walk-in, no mostrar el botón
  if (appointment.status === 'Walk in') {
    return null;
  }

  return (
    <Tooltip title="Mark as Walk-in Appointment" arrow>
      <IconButton
        size="small"
        disabled={isDisabled()}
        sx={{
          backgroundColor: isDisabled() ? '#cccccc' : '#000000',
          color: 'white',
          '&:hover': { 
            backgroundColor: isDisabled() ? '#cccccc' : '#333333' 
          },
          '&:disabled': {
            color: '#666666'
          },
          width: 24,
          height: 24,
        }}
        onClick={handleWalkInClick}
      >
        <WalkInIcon sx={{ fontSize: 14 }} />
      </IconButton>
    </Tooltip>
  );
};

export default WalkinButtonComponent;